import { render, staticRenderFns } from "./ProductPackageImportsView.vue?vue&type=template&id=7952dff9"
import script from "./ProductPackageImportsView.vue?vue&type=script&lang=ts"
export * from "./ProductPackageImportsView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports